import React from "react";
import { CheckBox } from "components/Form/FormikControls/CheckBox";
import { useSelector } from "react-redux";
import { getDefaultBillingSettings } from "selectors";

interface DebtorInsuranceCheckboxProps {
  name: string;
  label: string;
  disabled?: boolean;
}

export const DebtorInsuranceCheckbox: React.FC<
  DebtorInsuranceCheckboxProps
> = ({ name, label, disabled = false }) => {
  const billingSettings = useSelector(getDefaultBillingSettings);
  const debtorInsurance = billingSettings
    ? billingSettings.debtorInsurance
    : { insuredDefinedByProvider: false };

  return (
    <CheckBox
      label={label}
      name={name}
      disabled={debtorInsurance?.insuredDefinedByProvider || disabled}
      tooltip={
        debtorInsurance?.insuredDefinedByProvider
          ? "Insured status is set by the insurance provider"
          : ""
      }
    />
  );
};
